<div class="bar" [ngClass]="'theme-' + themeColor">
  <div class="progress" [style.width]="value + '%'"></div>
</div>
